/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Usersessionhuburlclientsecret5Inputs */

const en_entity_usersessionhuburlclientsecret5 = /** @type {(inputs: Entity_Usersessionhuburlclientsecret5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Session Hub Client Secret`)
};

const de_entity_usersessionhuburlclientsecret5 = /** @type {(inputs: Entity_Usersessionhuburlclientsecret5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Session Hub Client Secret`)
};

/**
* | output |
* | --- |
* | "User Session Hub Client Secret" |
*
* @param {Entity_Usersessionhuburlclientsecret5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_usersessionhuburlclientsecret5 = /** @type {((inputs?: Entity_Usersessionhuburlclientsecret5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Usersessionhuburlclientsecret5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_usersessionhuburlclientsecret5(inputs)
	return de_entity_usersessionhuburlclientsecret5(inputs)
});
export { entity_usersessionhuburlclientsecret5 as "entity_userSessionHubUrlClientSecret" }